import React from "react";

import { Box, Button, IconButton } from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";

import { DEFAULT_ZOOM_LEVEL } from "../../constants";

interface ZoomProps {
  zoomLevel: number;
  onZoomChange: (zoom: number) => void;
}

export default function Element({ zoomLevel, onZoomChange }: ZoomProps) {
  const handleZoomIn = () => {
    if (zoomLevel < 5) {
      onZoomChange(zoomLevel + 0.1);
    }
  };

  const handleZoomOut = () => {
    if (zoomLevel > 0.1) {
      onZoomChange(zoomLevel - 0.1);
    }
  };

  const handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onZoomChange(parseFloat(event.target.value));
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <IconButton
        size="small"
        onClick={handleZoomOut}
        sx={{ color: (theme) => theme.palette.text.secondary }}
      >
        <ZoomOutIcon fontSize="small" />
      </IconButton>
      <input
        type="range"
        min="0.1"
        max="5"
        step="0.1"
        value={zoomLevel}
        onChange={handleSliderChange}
        style={{ width: "100px", accentColor: "#1565c0" }}
      />
      <IconButton
        size="small"
        onClick={handleZoomIn}
        sx={{ color: (theme) => theme.palette.text.secondary }}
      >
        <ZoomInIcon fontSize="small" />
      </IconButton>
      <Button
        type="button"
        size="small"
        onClick={() => onZoomChange(DEFAULT_ZOOM_LEVEL)}
        sx={{
          cursor: "pointer",
          background: "none",
          border: "none",
          color: (theme) => theme.palette.text.secondary,
          textTransform: "uppercase",
          fontSize: "11px",
          fontWeight: 600,
          letterSpacing: "0.05em",
          "&:hover": {
            color: (theme) => theme.palette.text.primary,
            background: "none",
          },
        }}
      >
        Fit
      </Button>
    </Box>
  );
}
